export default __webpack_public_path__ + "static/media/solarumMinimium.584bbee0.png";